import React from "react";

import { useTranslation } from "react-i18next";

import RadioButton from "../../../../../../../../../../../../components/Form/RadioGroup";
import { TimesheetOptions } from "../../../../../../../../../../../../util/enums/members";
import { CardComponent } from "../../../../Card";
import useStyles, { CardWrapper, Header, Message, Title } from "./styles";

type TimesheetFirstStepProps = {
  option: string;
  setOption: (option: string) => void;
};

export const TimesheetFirstStep: React.FC<TimesheetFirstStepProps> = ({ option, setOption }) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <Header>
        <Message>{translate("addWorkTimeToMember")}</Message>
        <Title>{translate("howDoYouWantToAddAnewTime")}?</Title>
      </Header>
      <CardWrapper>
        <CardComponent.Root
          isActive={option === TimesheetOptions.MOCK_OPTION}
          onClick={() => setOption(TimesheetOptions.MOCK_OPTION)}
        >
          <CardComponent.Content>
            <RadioButton
              value={option}
              options={[
                {
                  label: "",
                  value: TimesheetOptions.MOCK_OPTION,
                  asideChild: {
                    child: (
                      <CardComponent.Title isActive={option === TimesheetOptions.MOCK_OPTION}>
                        {translate("createMockTask")}
                      </CardComponent.Title>
                    ),
                    classnames: classes.radioLabel,
                  },
                },
              ]}
              onChange={(event) => setOption(event.target.value)}
            />
            <CardComponent.Subtitle>
              {translate("createAMimicTaskToRecordHoursForThisMember")}
            </CardComponent.Subtitle>
          </CardComponent.Content>
        </CardComponent.Root>
        <CardComponent.Root
          isActive={option === TimesheetOptions.EXISTENT_OPTION}
          onClick={() => setOption(TimesheetOptions.EXISTENT_OPTION)}
        >
          <CardComponent.Content>
            <RadioButton
              value={option}
              options={[
                {
                  label: "",
                  value: TimesheetOptions.EXISTENT_OPTION,
                  asideChild: {
                    child: (
                      <CardComponent.Title isActive={option === TimesheetOptions.EXISTENT_OPTION}>
                        {translate("selectExistentTask")}
                      </CardComponent.Title>
                    ),
                    classnames: classes.radioLabel,
                  },
                },
              ]}
              onChange={(event) => setOption(event.target.value)}
            />
            <CardComponent.Subtitle>
              {translate("selectAnExistingTaskInTHeOrderToLogWorkTime")}
            </CardComponent.Subtitle>
          </CardComponent.Content>
        </CardComponent.Root>
      </CardWrapper>
    </>
  );
};
